var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useMemo, useState } from 'react';

import { useLoaderData } from 'react-router-dom';
import * as pxEntitiesApi from "../../../api/paragraphExtractor/entities";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Table } from "../../../Components/UI";
import { RequestParams } from "../../../../utils/RequestParams";

import { I18NApi } from "../../../../I18N";

import { templatesAtom } from "../../../atoms";
import { useAtomValue } from 'jotai';
import { tableColumns } from "./components/PXEntityTableElements";
import { TableTitle } from "./components/TableTitle";

import { getTemplateName } from "./utils/getTemplateName";

const formatEntityData = (
entities,
templates,
languagePool) =>

entities.map((entity) => {
  const templateName = getTemplateName(templates, entity.templateId);
  const languages = entity.languages.map((language) => {
    const { label = language } = languagePool.find((pool) => pool.key === language) || {};
    return label;
  });
  return _objectSpread(_objectSpread({},
  entity), {}, {
    rowId: entity._id || '',
    templateName,
    languages });

});

const PXEntityDashboard = () => {
  const [templatesFrom, setTemplatesFrom] = useState([]);
  const { entities = [], languages = [] } = useLoaderData();



  const templates = useAtomValue(templatesAtom);
  const pxEntitiesData = useMemo(
    () => formatEntityData(entities, templates, languages),
    [entities, templates, languages]
  );

  useEffect(() => {
    const uniqueTemplateNames = [...new Set(pxEntitiesData.map((datum) => datum.templateName))];
    setTemplatesFrom(uniqueTemplateNames.filter(Boolean));
  }, [pxEntitiesData]);

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      "data-testid": "settings-paragraph-extractor",
      style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: "Entities",
      path: new Map([['Paragraph extraction', '/settings/paragraph-extraction']]) }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: pxEntitiesData,
      columns: tableColumns,
      header: /*#__PURE__*/_jsx(TableTitle, { items: templatesFrom }),
      defaultSorting: [{ id: '_id', desc: false }] }
    )
    )
    )
    ));

};

const PXEntityLoader =
(headers) =>
async ({ params: { extractorId = '' } }) => {
  const [entities, languages] = await Promise.all([
  pxEntitiesApi.getByParagraphExtractorId(extractorId),
  I18NApi.getLanguages(new RequestParams({}, headers))]
  );
  return { entities, languages };
};

export { PXEntityDashboard, PXEntityLoader };